import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsersGiftCardComponent } from './users-gift-card/users-gift-card.component';
import { IonicModule } from '@ionic/angular';
import { GeneralesComponentsModule } from 'src/app/generales-components/generales-components.module';
import { HistoryUsersComponent } from './history-users/history-users.component';
import { FormsModule } from '@angular/forms';
import { PipeModule } from 'src/app/pipes/pipe-module.module';
import { FormMyGiftCardsComponent } from 'src/app/components/form-my-gift-cards/form-my-gift-cards.component';
import { FormMyGiftCardsCardPreviewComponent } from 'src/app/components/form-my-gift-cards-card-preview/form-my-gift-cards-card-preview.component';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsAdminModule } from '../../../componentsAdmin/components-admin.module';
import { DetailHistoryUsersComponent } from './detail-history-users/detail-history-users.component';

const declarations = [
  UsersGiftCardComponent,
  HistoryUsersComponent,
  FormMyGiftCardsComponent,
  FormMyGiftCardsCardPreviewComponent,
  DetailHistoryUsersComponent,
];

@NgModule({
  declarations,
  imports: [
    CommonModule,
    IonicModule,
    GeneralesComponentsModule,
    FormsModule,
    PipeModule,
    TranslateModule,
    ComponentsAdminModule,
  ],
  exports: declarations,
})
export class GiftCardComponentsModule {}
